import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
  useGetWaterLevelDataQuery,
  useGetApiQuery,
  useGetWaterLevelAPIQuery,
} from "../../redux/services/apiHome";
import DateFilter from "../../components/DateFilter";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";

const WaterTemp = () => {
  const { id } = useParams();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  function formatTime(hours, minutes) {
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}`;
  }

  const [dateInput, setDateInput] = useState(
    new Date().toISOString().split("T")[0],
  );

  const { data: waterLevelData = [] } = useGetWaterLevelAPIQuery({
    date: dateInput,
  });

  console.log(waterLevelData);

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Reservoir Status", "जलाशय स्थिति")}
        titleLink="/reservoir-status"
        titleLink2={"/reservoir-status"}
        titleTwo={getText("Water Levels", "जल स्तर")}
        // titleThree={reservoirObj?.title}
        levelTwo={true}
        levelThree={true}
        // isActive={reservoirObj?.title}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-2 col-lg-12 mb-3">
                <DateFilter dateInput={dateInput} setDateInput={setDateInput} />
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>
                          {getText("Time", "समय")}
                          <br></br>({getText("HH:MM", "घंटे:मिनट")})
                        </th>
                        <th>
                          {getText(
                            "Water Level (in meter)",
                            "जल स्तर (मीटर में)",
                          )}
                        </th>
                        <th>{getText("Spilling Status", "स्पिलिंग स्थिति")}</th>
                        <th>{getText("Gate 1", "गेट 1")}</th>
                        <th>{getText("Gate 2", "गेट 2")}</th>
                        <th>{getText("Gate 3", "गेट 3")}</th>
                        <th>{getText("Gate 4", "गेट 4")}</th>
                        <th>{getText("Gate 5", "गेट 5")}</th>
                        <th>{getText("Gate 6", "गेट 6")}</th>
                        <th>
                          {getText(
                            "Discharge in Cumecs",
                            "क्यूमेक्स में डिस्चार्ज",
                          )}
                        </th>
                        <th>{getText("Remarks", "टिप्पणियाँ")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {waterLevelData.length > 0 ? (
                        waterLevelData.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {formatTime(
                                item.field_dam_water_lever_time_hh,
                                item.field_dam_water_lever_time_mm,
                              )}
                            </td>
                            <td>{item.field_water_level}</td>
                            <td>{item.field_dam_spilling_status}</td>
                            <td>{item.field_list_gate_1}</td>
                            <td>{item.field_list_gate_2}</td>
                            <td>{item.field_list_gate_3}</td>
                            <td>{item.field_list_gate_4}</td>
                            <td>{item.field_list_gate_5}</td>
                            <td>{item.field_list_gate_6}</td>
                            <td>{item.field_discharge_in_cumecs}</td>
                            <td>{item.field_dam_remark}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center">
                            {getText(
                              "No records found",
                              "कोई रिकॉर्ड नहीं मिला",
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WaterTemp;
